import React from 'react';
import HeaderMenu from './HeaderMenu';
import Footer from './Footer';
import './Layout.scss';

const Layout = ({children, ...props}) => (
  <div {...props}>
    <HeaderMenu />
    <div className="pcbang-contents">{children}</div>
    <Footer />
  </div>
);

export default Layout;
